import { TableBatchBuilder } from '@loaders.gl/schema';
import { ArrowTableBatchAggregator } from "./lib/arrow-table-batch.js";
TableBatchBuilder.ArrowBatch = ArrowTableBatchAggregator;
export { getArrowType } from "./schema/arrow-type-utils.js";
export { VECTOR_TYPES } from "./types.js";
export { ArrowLoader, ArrowWorkerLoader } from "./arrow-loader.js";
export { ArrowWriter } from "./arrow-writer.js";
export { GeoArrowLoader, GeoArrowWorkerLoader } from "./geoarrow-loader.js";
export { serializeArrowSchema, deserializeArrowSchema, serializeArrowMetadata, deserializeArrowMetadata, serializeArrowField, deserializeArrowField, serializeArrowType, deserializeArrowType } from "./schema/convert-arrow-schema.js";
export { getBinaryGeometryTemplate, getBinaryGeometriesFromArrow, getTriangleIndices, getMeanCentersFromBinaryGeometries } from "./geoarrow/convert-geoarrow-to-binary-geometry.js";
export { updateBoundsFromGeoArrowSamples } from "./geoarrow/get-arrow-bounds.js";
export { parseGeometryFromArrow } from "./geoarrow/convert-geoarrow-to-geojson-geometry.js";
export { convertArrowToGeoJSONTable } from "./tables/convert-arrow-to-geojson-table.js";
export { hardClone } from "./workers/hard-clone.js";
export { TriangulationWorker, triangulateOnWorker, parseGeoArrowOnWorker } from "./triangulate-on-worker.js";
//# sourceMappingURL=index.js.map